<template>
  <f7-list-item>
    <div>
      <f7-link :href="`/stores/${storeId}/menus/${menuVariation}/menu-time-selection/${weekdayIndex}-${businessHourIndex}-start`">
        {{ startValue }}
        <font-awesome-icon icon="edit" style="margin-left: 5px;" />
      </f7-link>
      <span>~</span>
      <f7-link :href="`/stores/${storeId}/menus/${menuVariation}/menu-time-selection/${weekdayIndex}-${businessHourIndex}-end`">
        {{ endValue }}
        <font-awesome-icon icon="edit" style="margin-left: 5px;" />
      </f7-link>
    </div>
    <div>
      <font-awesome-icon icon="trash" @click="$emit('delete')" style="color: red;" />
    </div>
  </f7-list-item>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['menuVariation', 'weekdayIndex', 'businessHourIndex', 'businessHours'],
  computed: {
    ...mapGetters(['storeId']),
    businessHour () { return this.businessHours[this.businessHourIndex] },
    startValue () { return this.businessHour[0] },
    endValue () { return this.businessHour[1] }
  }
}
</script>
